export default "https://assets.egbcdn.net/assets/packs/_/images/beer/beer-background-7b2174b079a0a8af97aded7c4cffeda8.png";